import { BBDTag, MaterialIcon } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import type React from 'react'

interface BookTypeCellRendererProps {
  value: string
}

export const BookTypeCellRenderer: React.FC<BookTypeCellRendererProps> = ({ value }) => {
  if (!value) return null

  return value === 'Cost' ? (
    <Tooltip title='Cost'>
      <BBDTag
        style={{
          width: 'fit-content',
          display: 'flex',
          alignItems: 'center',
        }}
        error
      >
        <MaterialIcon size={15} icon='shadow_minus' />
      </BBDTag>
    </Tooltip>
  ) : (
    <Tooltip title='Revenue'>
      <BBDTag
        style={{
          width: 'fit-content',
          display: 'flex',
          alignItems: 'center',
        }}
        success
      >
        <MaterialIcon size={15} icon='payments' />
      </BBDTag>
    </Tooltip>
  )
}
